import { LAYOUTS, } from '@voltmoney/types';
import { ROUTE } from '../../../../routes';
import { WIDGET } from '@voltmoney/schema';
import { api } from '../../../../configs/api';
import { getAppHeader } from '../../../../configs/config';
import SharedPropsService from '../../../../SharedPropsService';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { PollarStatus } from './utils';
export const template = async (height) => {
    return {
        layout: {
            id: ROUTE.MFC_FETCH_EVALUTE_FUNDS,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: 'mfCentralEvaluateFundsDC',
                    type: WIDGET.MFC_FETCH_EVALUATE_FUNDS,
                },
            ],
        },
        datastore: {
            mfCentralEvaluateFundsDC: {
                height: height,
            },
        },
    };
};
export const mfCentralEvaluateFundsMF = {
    onLoad: async ({ getHeight, network, navigateWithClear, navigateToBase }) => {
        const user = await SharedPropsService.getUser();
        const applicationId = (await AsyncStorage.getItem('application_id')) !== null
            ? await AsyncStorage.getItem('application_id')
            : user.linkedApplications[0].applicationId;
        const callGetMFCFundsPollar = async () => {
            const getMFCFundsPollarResponse = await network.get(`${api.getMFCFundsPollar}${applicationId}`, { headers: await getAppHeader() });
            const pollarStatus = getMFCFundsPollarResponse?.data?.status;
            if (getMFCFundsPollarResponse?.status === 200) {
                if (pollarStatus !== PollarStatus.IN_PROGRESS) {
                    clearInterval(getMFCFundsPollar);
                    if (pollarStatus === PollarStatus.SUCCESS) {
                        const pledgeLimitResponse = await network.get(`${api.pledgeLimit}${applicationId}`, { headers: await getAppHeader() });
                        const minimumEligibleLimit = pledgeLimitResponse?.data?.stepResponseObject
                            ?.minimumEligibleLimit?.amount;
                        const availableCreditAmount = pledgeLimitResponse?.data?.stepResponseObject
                            ?.availableCreditAmount;
                        availableCreditAmount >= minimumEligibleLimit
                            ? navigateWithClear(ROUTE.MFC_FETCH_LANDING)
                            : navigateWithClear(ROUTE.MFC_FETCH_ANCHOR);
                    }
                    else {
                        const errorResponse = getMFCFundsPollarResponse?.data?.error;
                        navigateToBase(ROUTE.MF_FETCH_PORTFOLIO);
                        await SharedPropsService.setMFCentralFetchError(errorResponse);
                    }
                }
            }
        };
        callGetMFCFundsPollar();
        const getMFCFundsPollar = setInterval(callGetMFCFundsPollar, 5000);
        return Promise.resolve(template(getHeight()));
    },
    actions: {},
    clearPrevious: true,
};
